import { render, staticRenderFns } from "./StudentHistory.vue?vue&type=template&id=01e95132"
import script from "./StudentHistory.vue?vue&type=script&lang=js"
export * from "./StudentHistory.vue?vue&type=script&lang=js"
import style0 from "./StudentHistory.vue?vue&type=style&index=0&id=01e95132&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports